/* eslint-disable no-undef */
export const placeRequest = (request) => new Promise((resolve, reject) => new google.maps.places
  .PlacesService(
    document.createElement('div'),
  ).getDetails(request, (place, status) => {
    if (status === google.maps.places.PlacesServiceStatus.OK) {
      resolve(place);
    } else {
      reject();
    }
  }));

const componentForm = {
  street_number: 'short_name',
  route: 'long_name',
  locality: 'long_name',
  administrative_area_level_1: 'long_name',
  country: 'long_name',
  postal_code: 'short_name',
};

export const getFullAddressInfo = (addressComponents) => {
  const fullAddressInfo = {};
  for (let i = 0; i < addressComponents.length; i += 1) {
    const addressType = addressComponents[i].types[0];
    if (componentForm[addressType]) {
      const val = addressComponents[i][componentForm[addressType]];
      fullAddressInfo[addressType] = val;
    }
  }
  return fullAddressInfo;
};
